import { render, staticRenderFns } from "./PublicWelfare.vue?vue&type=template&id=57906974&scoped=true"
import script from "./PublicWelfare.vue?vue&type=script&lang=js"
export * from "./PublicWelfare.vue?vue&type=script&lang=js"
import style0 from "./PublicWelfare.vue?vue&type=style&index=0&id=57906974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57906974",
  null
  
)

export default component.exports